import { useField } from 'formik';
import { FormField, PasswordInput as BlueberryPasswordInput } from '@neshane/blueberry';

/**
 * Password Input Component for Admin Login
 * Handles password field with validation
 * Matches Operator login styling using Blueberry PasswordInput with show/hide toggle
 */
function PasswordInput({ disabled = false }) {
    const [field, meta] = useField('password');
    const hasError = meta.touched && meta.error;

    return (
        <FormField label="رمز عبور" alertMessage={hasError ? meta.error : undefined}>
            <BlueberryPasswordInput
                name="password"
                fit="parent"
                placeholder="رمز عبور"
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                isDisabled={disabled}
                isInvalid={Boolean(hasError)}
            />
        </FormField>
    );
}

export default PasswordInput;
